import { APPLE_PODCAST_URL, SPOTIFY_PODCAST_URL } from '../lib/podcastPlatforms';

const PODCAST_IMAGES = `${process.env.PUBLIC_URL}/images/podcasts`;
const YOUTUBE_CHANNEL_VIDEOS_URL = 'https://www.youtube.com/@SBR2THTalent/videos';

export type PodcastShow = {
  id: string;
  title: string;
  category: string;
  image: string;
  youtubePlaylistId: string;
  accent?: 'teal' | 'blue';
};

export function getPodcastShowById(showId: string): PodcastShow | undefined {
  return PODCAST_SHOWS.find((show) => show.id === showId);
}

export function getPodcastShowPlaylistUrl(show: PodcastShow): string {
  return `https://www.youtube.com/playlist?list=${show.youtubePlaylistId}`;
}

export const PODCAST_SHOWS: PodcastShow[] = [
  {
    id: 'c-suite-edge',
    title: 'C-Suite Edge',
    category: 'Executive Leadership',
    image: `${PODCAST_IMAGES}/c suite edge.png`,
    youtubePlaylistId: 'PL8DsjBf87cNCUWRQ7VBjc9aTg_5HqFxWx',
    accent: 'teal',
  },
  {
    id: 'inside-human-capital',
    title: 'Inside Human Capital',
    category: 'Human Capital Insights',
    image: `${PODCAST_IMAGES}/inside human capital.png`,
    youtubePlaylistId: 'PL8DsjBf87cNCUr_d95NbhR9sXBVHLY5jG',
    accent: 'teal',
  },
  {
    id: 'inside-open-technologies',
    title: 'Inside Open Technologies',
    category: 'Technology & Innovation',
    image: `${PODCAST_IMAGES}/inside open technoogies.png`,
    youtubePlaylistId: 'PL8DsjBf87cNC78cWM9HY4ugR6MfMiDmiu',
    accent: 'blue',
  },
  {
    id: 'drowning-in-the-talent-pool',
    title: 'Drowning in the tech talent pool',
    category: 'Talent Acquisition Strategies',
    image: `${PODCAST_IMAGES}/drowing in tech pool.png`,
    youtubePlaylistId: 'PL8DsjBf87cNAtL757e7N8uTnPU77KWgm3',
    accent: 'teal',
  },
];

export const PODCAST_LISTEN_PLATFORMS = [
  {
    id: 'apple',
    label: 'Apple Podcasts',
    href: APPLE_PODCAST_URL,
    icon: `${process.env.PUBLIC_URL}/images/applepodcast.png`,
    enabled: false,
  },
  {
    id: 'spotify',
    label: 'Spotify',
    href: SPOTIFY_PODCAST_URL,
    icon: `${process.env.PUBLIC_URL}/images/spotify.png`,
    enabled: false,
  },
  {
    id: 'youtube',
    label: 'YouTube',
    href: YOUTUBE_CHANNEL_VIDEOS_URL,
    icon: `${process.env.PUBLIC_URL}/images/youtube.png`,
    enabled: true,
  },
] as const;
